/**
 * @ngdoc directive
 * @name lspFieldMatchingValidator.directive:lspMatchDirective
 * @description
 * # lspMatch
 */

function lspMatch() {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      lspMatch: '=',
      lspMatchCaseInsensitive: '=?',
    },
    link: (scope, elem, attrs, ctrl) => {
      if (!ctrl) {
        // 'Match validation requires ngModel to be on the element'
        return;
      }

      scope.$watch('lspMatch', (newVal, oldVal) => {
        if (newVal !== oldVal) {
          ctrl.$validate();
        }
      });

      ctrl.$validators.lspMatch = () => {
        if (scope.lspMatchCaseInsensitive) {
          if (ctrl.$viewValue === undefined) {
            return true;
          }
          if (scope.lspMatch === undefined) {
            return false;
          }
          return ctrl.$viewValue.toUpperCase() === scope.lspMatch.toUpperCase();
        }
        return ctrl.$viewValue !== undefined ? ctrl.$viewValue === scope.lspMatch : true;
      };
    },
  };
}

export default lspMatch;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/lsp-field-matching-validator/lsp-field-matching-directive.js